import { BillingAddress } from "../../../types/payment"

interface BillingAddressDisplayProps {
  address: BillingAddress
}

const BillingAddressDisplay = ({ address }: BillingAddressDisplayProps) => {
  if (!address.line1) {
    return <div className="text-gray-500">No address on file</div>
  }

  return (
    <div className="text-gray-700">
      <div>{address.line1}</div>
      {address.line2 && <div>{address.line2}</div>}
      <div>
        {address.city}, {address.state} {address.postal_code}
      </div>
      <div>{address.country}</div>
    </div>
  )
}

export default BillingAddressDisplay
